var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbcDwellTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14161_103889)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_14161_103889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 11H20.5C16.0817 11 12.5 14.5817 12.5 19V59C12.5 63.4183 16.0817 67 20.5 67H59.5C63.9183 67 67.5 63.4183 67.5 59V19C67.5 14.5817 63.9183 11 59.5 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 12.5H20.5C16.9101 12.5 14 15.4101 14 19V59C14 62.5899 16.9101 65.5 20.5 65.5H59.5C63.0899 65.5 66 62.5899 66 59V19C66 15.4101 63.0899 12.5 59.5 12.5Z",
    stroke: "#FF8027",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6046 49.6046C48.5072 51.7027 45.8347 53.1316 42.9252 53.7106C40.0156 54.2897 36.9997 53.9928 34.2589 52.8576C31.518 51.7224 29.1754 49.7999 27.5273 47.3332C25.8792 44.8665 24.9997 41.9664 25 38.9998H26.875C26.8754 41.5951 27.6453 44.132 29.0874 46.2898C30.5295 48.4475 32.579 50.1292 34.9769 51.1222C37.3747 52.1152 40.0131 52.3749 42.5585 51.8685C45.1039 51.3621 47.442 50.1123 49.2772 48.2771C51.1123 46.442 52.3621 44.1039 52.8685 41.5585C53.3749 39.0131 53.1152 36.3746 52.1222 33.9768C51.1292 31.579 49.4475 29.5295 47.2897 28.0874C45.132 26.6453 42.5951 25.8754 39.9998 25.875V30.9724H38.1248V24H39.9998C42.9664 23.9997 45.8665 24.8792 48.3332 26.5272C50.8 28.1753 52.7225 30.5179 53.8577 33.2588C54.9929 35.9997 55.2898 39.0156 54.7107 41.9252C54.1317 44.8348 52.7027 47.5072 50.6046 49.6046ZM43.3267 38.7994C43.3267 39.7953 42.9311 40.7503 42.2269 41.4545C41.5228 42.1586 40.5677 42.5542 39.5719 42.5542C38.5761 42.5542 37.6211 42.1586 36.9169 41.4545C36.2128 40.7503 35.8172 39.7953 35.8172 38.7994C35.8172 38.7767 35.8234 38.7558 35.8238 38.7332L26.875 36.2174L27.3825 34.42L36.3296 36.9377C36.7385 36.2187 37.374 35.6555 38.1367 35.3358C38.8995 35.0162 39.7467 34.9582 40.546 35.1708C41.3452 35.3835 42.0515 35.8549 42.5546 36.5113C43.0577 37.1678 43.3292 37.9724 43.3267 38.7994ZM41.5767 38.7994C41.5767 38.403 41.4591 38.0154 41.2388 37.6857C41.0185 37.356 40.7054 37.0991 40.3391 36.9474C39.9728 36.7956 39.5697 36.7559 39.1808 36.8333C38.7919 36.9106 38.4347 37.1016 38.1543 37.3819C37.874 37.6623 37.683 38.0195 37.6057 38.4084C37.5283 38.7973 37.568 39.2004 37.7198 39.5667C37.8715 39.933 38.1284 40.2461 38.4581 40.4664C38.7878 40.6867 39.1754 40.8043 39.5718 40.8043C40.1034 40.8037 40.613 40.5923 40.9888 40.2164C41.3647 39.8406 41.5761 39.331 41.5767 38.7994Z",
    fill: "#FF8027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14161_103889",
    x: 0.5,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14161_103889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14161_103889",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_14161_103889",
    x: 0.5,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14161_103889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14161_103889",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_14161_103889"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbcDwellTime);
export default __webpack_public_path__ + "static/media/EBC-dwell-time.6c1fa0cf0314efbc4dc56748de965298.svg";
export { ForwardRef as ReactComponent };